// extracted by mini-css-extract-plugin
module.exports = {"simple-form-component":"simpleForm_simple-form-component__vC4w0"};